import { render, staticRenderFns } from "./PanelsView.vue?vue&type=template&id=6a0c51d9"
import script from "./PanelsView.vue?vue&type=script&lang=js"
export * from "./PanelsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports